
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/b/[[...slug]]",
      function () {
        return require("private-next-pages/b/[[...slug]].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/b/[[...slug]]"])
      });
    }
  